import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {connect} from 'react-redux';
import Checkbox from "../../../public/journey1/fragments/services/Checkbox";
import PriceTag from '../../common/pricetag/PriceTag';

class ValueServicesCart extends Component {

  render() {
    const {intl:{formatMessage}, cart} = this.props;
    return (
      <div>
        <h3 className="box__subtitle">{formatMessage({id:'appointment.detail.services.value-services.title'})} {`${cart.total} €`}</h3>
        <ul className="list">
        {cart.items.map(item=>{
          return <li key={item.id}><Checkbox disabled={true} checked={true}>
            {item.name} - <PriceTag price={item.price}/>
          </Checkbox>
          </li>
        })}
        </ul>
      </div>
    )
  }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ValueServicesCart))
